import { Box, Flex, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import {
  Breadcrumbs,
  MetricDetails,
  PageHeader,
} from '@devd-client/devd/components';
import { getOrgId } from '@devd-client/devd/auth';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import DetailView from '../components/DetailView';
import ListView from '../components/ListView';
import { EngineerStatsTable } from '../components/EngineerStatsTable';
import { ProductStatsTable } from '../components/ProductStatsTable';
import { ReworkDensityTable } from '../components/ReworkDensityTable';
import { WorkflowStageTimeTable } from '../components/WorkflowStageTimeTable';
import { ReportQuestionItem } from '../helpers/report.types';

const ALL_REPORT_CATEGORIES = [
  {
    key: 'engineer',
    label: 'Contributor Report',
    description:
      'Track tickets, effort, and product contributions by contributor for the selected scope and date range.',
    orgs: ['HWQKVGYVA'],
  },
  {
    key: 'product',
    label: 'Product Report',
    description:
      'Track tickets, effort, and contributor involvement by product for the selected scope and date range.',
    orgs: ['HWQKVGYVA'],
  },
  {
    key: 'rework_density',
    label: 'Rework Density Report',
    description:
      'Analyse rework patterns and code churn to identify areas of recurring effort and improvement opportunities.',
    orgs: ['SSJWLIPBB'],
  },
  {
    key: 'workflow_stage_time',
    label: 'Workflow Stage Time by Component',
    description:
      'See the average time tickets spend in each workflow stage (Backlog, In Progress, In Review, Done, Archived), broken down by JIRA component.',
    orgs: ['SSJWLIPBB', 'OIDPPE'],
  },
];

const ReportPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const id = searchParams.get('id');
  const metricType = searchParams?.get('type');
  const reportType = searchParams.get('reportType');

  const currentOrgId = getOrgId() ?? '';
  const reportCategories = ALL_REPORT_CATEGORIES.filter((cat) =>
    cat.orgs.includes(currentOrgId)
  );

  // const [selectedItem, setSelectedItem] = useState<ReportQuestionItem | null>(
  //   null
  // );

  return (
    <>
      {!metricType ? (
        <Flex display={'flex'} flexDirection={'column'} width={'100%'}>
          {!id && !reportType ? (
            <PageHeader
              headingText="Reports"
              // tooltip="Answer key questions about team performance, delivery speed, developer well-being, and productivity. Each report is designed to surface insights around sprint health, feature throughput, burnout risk, and industry benchmarking—so you can make informed, data-driven decisions for your team."
            />
          ) : (
            <Box mb={2}>
              <Breadcrumbs />
            </Box>
          )}

          {!reportType ? (
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mt={4}>
              {reportCategories.map((cat) => (
                <Box
                  key={cat.key}
                  as="button"
                  textAlign="left"
                  bg="white"
                  border="1px solid"
                  borderColor="gray.200"
                  borderRadius="md"
                  px={5}
                  py={4}
                  transition="border-color 0.15s, background 0.15s"
                  _hover={{ bg: '#F6F7F9', borderColor: 'gray.300' }}
                  onClick={() => navigate(`?reportType=${cat.key}`)}
                >
                  <Text
                    fontFamily="heading"
                    fontSize="md"
                    fontWeight="semibold"
                    color="text.primary"
                  >
                    {cat.label}
                  </Text>
                  <Text
                    mt={1}
                    fontFamily="heading"
                    fontSize="sm"
                    fontWeight="medium"
                    color="text.secondary"
                  >
                    {cat.description}
                  </Text>
                </Box>
              ))}
            </SimpleGrid>
          ) : reportType === 'engineer' ? (
            <EngineerStatsTable />
          ) : reportType === 'product' ? (
            <ProductStatsTable />
          ) : reportType === 'rework_density' ? (
            <ReworkDensityTable />
          ) : reportType === 'workflow_stage_time' ? (
            <WorkflowStageTimeTable />
          ) : null}

          {/* <Stack spacing={3} w="full">
            {id ? (
              <DetailView selectedItem={selectedItem} />
            ) : (
              <ListView setSelectedItem={setSelectedItem} />
            )}
          </Stack> */}
        </Flex>
      ) : (
        <MetricDetails />
      )}
    </>
  );
};

export default ReportPage;
